// doc: https://white-light.feishu.cn/wiki/AOqCwJDqViiZgOkYUtpcq0dzn6b

import { defineApi } from '@/utils/fetch';

import type {
    IGetDramaListParams,
    IGetDramaListResponse,
    IGetSuggestListParams,
    IGetSuggestListResponse,
} from './typings';

export const SearchApi = {
    /** 检索短剧列表 */
    getDramaList: defineApi<IGetDramaListParams, IGetDramaListResponse>({
        url: '/drama_search/list',
        method: 'GET',
    }),
    /** 检索建议词 */
    getSuggestList: defineApi<IGetSuggestListParams, IGetSuggestListResponse>({
        url: '/drama_search/suggest',
        method: 'GET',
    }),
};

export * from './typings';
